import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form"
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Avatar,
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Typography,
  Container
} from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";

// Contexts
import LayoutContext from "../../context/layout/LayoutContext";
import AuthContext from "../../context/auth/AuthContext";

// Components
import Footer from "../layout/Footer";
import validator from 'validator'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.light,
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Login = (props) => {

  const { handleSubmit, register, errors } = useForm();

  const classes = useStyles();
  const history = useHistory();

  const { setAlert } = useContext(LayoutContext);
  const { login, error, clearErrors, isAuthenticated } =
    useContext(AuthContext);

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const [emailError, setEmailError] = useState({
    emailError: ""
  });

  const { email, password } = user;

  const onChange = (e) => {
    if(e.target.name === "email") {
      setEmailError({...emailError, emailError: !validator.isEmail(e.target.value)})
    }
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    if (email === "" || password === "") {
      setAlert("Please fill in all fields.", "error");
    } else {
      login({
        email,
        password,
      });
    }
  };

  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/");
      history.push("/");
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (error) {
      setAlert(error, "error");
      clearErrors();
    }
  }, [error]);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />

      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit(onSubmit)}>
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="normal"
            {...register('email',{
              required: "Email is required",
              pattern: {
                value: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: "Please enter a valid email."
              }
            })}
            id="email"
            name="email"
            label="Email"
            autoFocus
            value={email}
            onChange={onChange}
            error={Boolean(emailError?.emailError)}
            // error={Boolean(errors?.email)}
            helperText={(errors?.email.message)}
          />
          <TextField
            required
            fullWidth
            variant="outlined"
            margin="normal"
            type="password"
            id="password"
            name="password"
            label="Password"
            value={password}
            onChange={onChange}
          />
          <Button
            fullWidth
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            className={classes.submit}
          >
            Sign In{" "}
          </Button>
          <Grid container justifyContent="flex-end">
            <Grid item>
              {" "}
              {/* <Link href="/forget-password" variant="body2"> */}{" "}
              <Link
                variant="body2"
                onClick={() => history.push("/register")}
              >
                Register New User
              </Link>{" "}
            </Grid>{" "}
          </Grid>{" "}
          <Grid container justifyContent="flex-end">
            <Grid item>
              {" "}
              {/* <Link href="/forget-password" variant="body2"> */}{" "}
              <Link
                variant="body2"
                onClick={() => history.push("/forget-password")}
              >
                Forgot password ?
              </Link>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </form>{" "}
      </div>

      <Footer />
    </Container>
  );
};

export default Login;
